import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'
import {useOrganization} from 'organization/OrganizationProvider'
import React from 'react'
import Button from '@material-ui/core/Button'
import {useServices} from 'organization/Event/Services/ServicesProvider'
import {useToggle} from 'lib/toggle'
import {HighLevelIntegration} from '..'

export default function ImportAttendeesButton(props: {
  onSuccess: () => void
  onError: (error: string) => void
}) {
  const {update: updateIntegration} = useServices()
  const importAttendees = useImportUsers()
  const {flag: processing, toggle: toggleProcessing} = useToggle()

  const handleImport = () => {
    if (processing) {
      return
    }

    toggleProcessing()

    importAttendees()
      .then((integration) => {
        updateIntegration(integration)
        props.onSuccess()
      })
      .catch((e) => {
        props.onError(e.message)
      })
      .finally(() => {
        toggleProcessing()
      })
  }

  return (
    <Button
      variant="outlined"
      color="primary"
      aria-label="import attendees"
      onClick={handleImport}
      disabled={processing}
    >
      Import Attendees
    </Button>
  )
}

function useImportUsers() {
  const {client} = useOrganization()
  const {event} = useEvent()
  const url = api(
    `/events/${event.id}/integrations/high_level/import_attendees`,
  )

  return () => client.post<HighLevelIntegration>(url)
}
